import type { CheckoutBasketDiscountInfoViewModel } from 'autogen/swagger/all';
import Layout from 'components/Layout';
import { Typography } from 'components/generic/typography';
import styled from 'styled-components';
import { Spacing4, Spacing8 } from 'autogen/design-tokens/tokens';
import type { DiscountInfoViewModel } from 'autogen/swagger/all';
import PotentialDiscounts from './PotentialDiscounts';
import ProgressiveDiscount from './ProgressiveDiscount';
import TriggeredDiscounts from './TriggeredDiscounts';

const ProgressiveDiscountContainer = styled(Layout.Flex.Row)`
    flex-wrap: wrap;
    row-gap: ${Spacing4};
    column-gap: ${Spacing8};
`;

export default function BasketDiscountInfo({
    model
}: {
    model: CheckoutBasketDiscountInfoViewModel | DiscountInfoViewModel;
}) {
    const { progressiveDiscount, excludedFromDiscountCommunication, triggeredDiscounts, potentialDiscounts } = model;

    const hasPotentialDiscounts = !!potentialDiscounts.length;
    const hasTriggeredDiscounts = !!triggeredDiscounts.length;

    const hasAnyDiscounts =
        progressiveDiscount || excludedFromDiscountCommunication || hasTriggeredDiscounts || hasPotentialDiscounts;

    if (!hasAnyDiscounts) return null;

    return (
        <ProgressiveDiscountContainer justifyContent="end">
            {progressiveDiscount && <ProgressiveDiscount model={model} />}
            {excludedFromDiscountCommunication && (
                <Typography.Body forwardedAs="span" size="S" strong>
                    {excludedFromDiscountCommunication}
                </Typography.Body>
            )}
            {hasTriggeredDiscounts && <TriggeredDiscounts model={triggeredDiscounts} />}
            {hasPotentialDiscounts && <PotentialDiscounts model={potentialDiscounts} />}
        </ProgressiveDiscountContainer>
    );
}
